// extracted by mini-css-extract-plugin
export var centerText = "_fe-8";
export var container = "_fe-0";
export var doughnutContainer = "_fe-7";
export var legend = "_fe-a";
export var legendItemColorDisplay = "_fe-b";
export var legendItemLabel = "_fe-d";
export var legendItemValue = "_fe-c";
export var lg = "_fe-5";
export var maxWidth = "_fe-9";
export var md = "_fe-4";
export var responsive = "_fe-6";
export var sm = "_fe-3";
export var xs = "_fe-2";
export var xxs = "_fe-1";